import uniq from 'lodash/uniq';

import { _QueryResources } from '@/lib/datx-jsonapi-react';
import { ThinEvent } from '@/resources/ThinEvent';
import { ThinLecture } from '@/resources/ThinLecture';

export const queryLecturesEventRelationships = (lectures: Array<ThinLecture>): _QueryResources<ThinEvent> => {
  return lectures?.length > 0
    ? [
        ThinEvent,
        {
          filter: {
            id: uniq(lectures.map(({ eventId }) => eventId)),
          },
        },
      ]
    : null;
};
